export default {
  indexPage: {
    title: 'A Blog About Doing Digital Differently',
    description:
      'Here you can find all our blog articles, founder interviews & tech talents portraits.',
  },
};
